




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Getter, Mutation } from 'vuex-class';
import { VuexMutation, PayFrequencyValues, Person, Output } from '@/types';
import CountUp from 'countup.js';
import _ from 'lodash';

@Component
export default class AnimatedNumber extends Vue {
  @Prop({ type: Number, default: 0 }) public value: number;
  @Prop({ type: Number, default: 0 }) public initial: number;
  @Prop({ type: Number, default: 0 }) public decimals: number;
  @Prop({ type: Number, default: 500 }) public time: number;
  @Prop({ type: Boolean, default: true }) public start: boolean;
  @Prop({ type: String, default: ',' }) public separator: string;
  @Prop({ type: String, default: '.' }) public decimal: string;
  @Prop({ type: String, default: '' }) public prefix: string;
  @Prop({ type: String, default: '' }) public suffix: string;
  @Prop({ type: Boolean, default: false }) public showArrow: boolean;
  @Prop({ type: Boolean, default: false}) public inverted: boolean;

  public countUp: any = {};
  public previous: string =  '';

  public get duration(): number {
    return this.time / 1000;
  }

  public get shouldShowArrow(): boolean {
    return this.showArrow && this.previous !== '';
  }

  public triggerReset() {
    this.previous = 'equal';
  }

  public created() {
    this.triggerReset = _.debounce(this.triggerReset, 1500).bind(this);
  }

  public mounted() {
    this.countUp = new CountUp(this.$el, this.initial, this.value ? this.value : 0, this.decimals, this.duration, {
      useEasing: true,
      useGrouping: true,
      separator: this.separator,
      decimal: this.decimal,
      prefix: this.prefix,
      suffix: this.suffix,
    });

    this.countUp.start();
  }

  @Watch('value')
  private watchValue(updated: number, old: number) {
    if (updated > old) {
      this.previous = 'higher';
    } else if (updated < old) {
      this.previous = 'lower';
    }

    if (this.inverted && this.value < 0) {
      this.countUp.update(updated * -1);
    } else {
      this.countUp.update(updated);
    }

    this.triggerReset();
  }
}
